import { render, staticRenderFns } from "./GroupClassPicker.vue?vue&type=template&id=6e48add4"
import script from "./GroupClassPicker.vue?vue&type=script&lang=js"
export * from "./GroupClassPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports